/**
 * @param {string|undefined|null} raw — ISO, YYYY-MM-DD, or with time
 * @returns {string} YYYY-MM-DD in local date parts, or ''
 */
export function toYmdDateOnly(raw) {
  if (raw == null) return '';
  const s = String(raw).trim();
  if (!s) return '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const t = s.includes('T') ? s : `${s}T12:00:00`;
  const d = new Date(t);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * @param {string} ymd - YYYY-MM-DD
 * @returns {number|null} calendar days from today 00:00 to ymd
 */
export function daysLeftFromYmd(ymd) {
  if (!ymd) return null;
  const a = toYmdDateOnly(ymd);
  if (!a) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const e = new Date(a + 'T12:00:00');
  if (Number.isNaN(e.getTime())) return null;
  e.setHours(0, 0, 0, 0);
  return Math.round((e - today) / 86400000);
}

/**
 * D-30 이상: safe (green) — strictly more than 30
 * D-30 이하 ~ D-7 초과: warn30 (orange)
 * D-7 이하 (만료 전): urgent7 (red)
 * 만료(음수): expired
 * @param {number|null|undefined} d
 */
export function visaUrgencyKey(d) {
  if (d == null) return 'none';
  if (d < 0) return 'expired';
  if (d > 30) return 'safe';
  if (d > 7) return 'warn30';
  return 'urgent7';
}

export function visaUrgencyClass(d) {
  const k = visaUrgencyKey(d);
  if (k === 'none') return 'mingo-visa-dday--na';
  return `mingo-visa-dday mingo-visa-dday--${k}`;
}

/** @param {number|null|undefined} d */
export function formatVisaDdayText(d) {
  if (d == null) return '—';
  if (d < 0) return '만료';
  return `D-${d}`;
}
